__turbopack_context__.v({
  "closeButton": "AppSearchDesktop-module-scss-module__VfofOW__closeButton",
  "divider": "AppSearchDesktop-module-scss-module__VfofOW__divider",
  "dropdown": "AppSearchDesktop-module-scss-module__VfofOW__dropdown",
  "modal": "AppSearchDesktop-module-scss-module__VfofOW__modal",
  "modalContent": "AppSearchDesktop-module-scss-module__VfofOW__modalContent",
  "root": "AppSearchDesktop-module-scss-module__VfofOW__root",
  "wrapper": "AppSearchDesktop-module-scss-module__VfofOW__wrapper",
});
